import React, { Component }  from "react";
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import useStyles from "./FormStyle"
import { withStyles } from '@material-ui/core/styles';
const checkInput = require("./CheckInput");

class ShowGeneralInfo extends Component {
    constructor(props) {
        super(props);
        let region = this.props.user.region;
        if (region.length === 0){
            region = "choose";
        }
        this.state = {
            full_name: this.props.user.full_name,
            phone_number: this.props.user.phone_number,
            region: region,
            city: this.props.user.city,
            errors: {
                full_name: '',
                phone_number: '',
                region: '',
                city:'',
            }        
        }
    }

    async componentWillMount() {
        if(this.props.user.full_name !== '') {
            this.setState({chosenRegion : true});
        }
    }

    checkAllIputValidation() {
        let errors = this.state.errors;
        errors.full_name = 
            !checkInput.nameCheck(this.state.full_name)
            ? 'שם פרטי אינו תקין'
            : '';
        // errors.city = 
        //     !checkInput.nameCheck(this.state.city)
        //     ? 'שם עיר אינו תקין'
        //     : '';
        errors.phone_number = 
            !checkInput.phoneCheck(this.state.phone_number)
            ? 'מספר טלפון אינו תקין'
            : '';
        errors.region =
            this.state.region === 'choose'
            ? 'נא בחר איזור מגורים'
            : '';
        if(this.state.errors.region === '') {
            if (!this.state.chosenRegion) {
                errors.region = 'נא בחר איזור מגורים';
            } else {
                errors.region = '';
            }
        }
        this.setState({errors}, ()=> {
            console.log(errors)
        })

        if(checkInput.validateForm(this.state.errors)) {
            return true;
        } else {
            return false;
        }
    }

    handleChange = evt => {
        var value = evt.target.value;
        var type = evt.target.name;
        let errors = this.state.errors;
        switch (type) {
            case "full_name":
                errors.full_name = 
                    !checkInput.nameCheck(value)
                    ? 'שם פרטי אינו תקין'
                    : '';
                break;
            break;
            // case "city":
            //     errors.city = 
            //         !checkInput.nameCheck(value)
            //         ? 'שם עיר אינו תקין'
            //         : '';
            //     break;
            case "phone_number":
                errors.phone_number = 
                    !checkInput.phoneCheck(value)
                    ? 'מספר טלפון אינו תקין'
                    : '';
                break;
            case "region":
                this.setState({chosenRegion : true});
                errors.region = 
                    value != "choose"
                    ? ''
                    :'נא בחר איזור מגורים';
                break;
        }
        this.setState({errors, [type]: value}, ()=> {
            console.log(errors)
        })
    }
    
    render(){
        const iconStyle = { position: 'absolute', left: 0, top: 0, pointerEvents : 'none'};
        const newIcon = (props) => {
            return (
                <svg xmlns="http://www.w3.org/2000/svg" style={iconStyle} width="32" height="32" viewBox="0 0 45 45">
                    <path fill="none" fillRule="evenodd" stroke="#979797" strokeWidth="2" d="M17 20l5.467 5.467L27.934 20"/>
                </svg>
            )
        };
        const {errors} = this.state;
        const errStyle = {
            color: 'red',
            fontSize: '12px',
            textAlign: 'right',
            fontWeight: 'bold',
          };
        const {classes} = this.props;
        return(
            <div>
                <div className={classes.input_text} style={{fontFamily:"Open Sans Hebrew"}}>
                    {this.props.full_name_label}
                </div>
                <TextField name="full_name"
                           onChange={this.handleChange}
                           defaultValue={this.state.full_name}
                           type="text"
                           fullWidth
                />
            <p>{errors.full_name.length > 0 && <span style={errStyle} className='error'>{errors.full_name}</span>}</p>
                <div className={classes.input_text}>
                    * טלפון 
                </div>
                <TextField name="phone_number"
                       onChange={this.handleChange}
                       defaultValue={this.state.phone_number}
                       type="tel"
                       fullWidth
                       native
                />
            <p>{errors.phone_number.length > 0 && <span className='error' style={errStyle}>{errors.phone_number}</span>}</p>
                <div className={classes.input_text}>
                    * אזור מגורים   
                </div>
                <FormControl fullWidth >
                    <Select
                        IconComponent={newIcon}
                        native name="region"
                        onChange={this.handleChange}
                        defaultValue={this.state.region} 
                        className={classes.input_text}>
                        <option value="choose"/>
                        <option value="center">מחוז מרכז</option>
                        <option value="north">מחוז צפון</option>
                        <option value="tel-aviv">מחוז תל-אביב</option>
                        <option value="haifa">מחוז חיפה</option>
                        <option value="south">מחוז דרום</option>
                        <option value="jerusalem">מחוז ירושלים</option>
                    </Select>
                    <p>{errors.region.length > 0 && <span className='error' style={errStyle}>{errors.region}</span>}</p>
                </FormControl>
                {/* <div className={classes.input_text}>
                   * עיר מגורים
                </div> */}
                {/* <TextField name="city"
                           onChange={this.handleChange}
                           defaultValue={this.state.city}
                           type="text"
                           fullWidth
                />
            <p>{errors.city.length > 0 && <span className='error' style={errStyle}>{errors.city}</span>}</p> */}
        </div>
        );
    }
}


export default  withStyles(useStyles)(ShowGeneralInfo)